import React, { useEffect, useMemo, useState } from "react";
import Styles from "./styles.module.scss";
import Seo from "../../components/_UI/seo";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProjectsAll } from "../../store/cabinet/action";
import { projectsStatusHandler } from "../../helpers/projectsStatusHandler";

const LaunchpadProjectsAllPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const projectsAll = useSelector((store) => store.cabinet.projectsAll);

    // локальный стейт страницы
    const [page, setPage] = useState(1);

    // грузим данные при изменении page
    useEffect(() => {
        dispatch(getProjectsAll({ page }));
    }, [dispatch, page]);

    // аккуратно достаём поля пагинации
    const projects = projectsAll?.projects?.data || [];
    const currentPage = projectsAll?.projects?.current_page || 1;
    const lastPage = projectsAll?.projects?.last_page || 1;

    // построение массива кнопок пагинации
    const paginationItems = useMemo(() => {
        const total = lastPage;
        const current = currentPage;
        if (total <= 1) return [];

        const items = [];
        const push = (val) => items.push(val);

        if (total <= 5) {
            for (let i = 1; i <= total; i++) push(i);
            return items;
        }

        if (current <= 3) {
            push(1);
            push(2);
            push(3);
            push("dots-right");
            push(total);
            return items;
        }

        if (current >= total - 2) {
            push(1);
            push("dots-left");
            push(total - 2);
            push(total - 1);
            push(total);
            return items;
        }

        // середина
        push(1);
        push("dots-left");
        push(current - 1);
        push(current);
        push(current + 1);
        push("dots-right");
        push(total);

        return items;
    }, [currentPage, lastPage]);

    const goToPage = (p) => {
        if (p < 1 || p > lastPage || p === currentPage) return;
        setPage(p);
    };

    const handlePrev = () => goToPage(currentPage - 1);
    const handleNext = () => goToPage(currentPage + 1);

    return (
        <section className={Styles.container}>
            <Seo title={t("Projects")} />
            <div className={Styles.contentWrap}>
                <div className={Styles.contentWrapTitle}>
                    <span>{t("Все")}</span> {t("Проекты")}
                </div>

                <div className={Styles.contentBox}>
                    {projects.length > 0
                        ? projects.map((item, index) => (
                            <div
                                className={Styles.contentBoxItem}
                                key={"projectsAllPage" + index}
                            >
                                <div className={Styles.projectAbsLogo}>
                                    <img src={item.logo} alt={item.title} />
                                </div>

                                <div
                                    className={Styles.projectInfo}
                                    onClick={() => {
                                        navigate(`/projects/${item.slug}`);
                                    }}
                                >
                                    <div
                                        className={Styles.projectInfoImgWrap}
                                        style={{
                                            backgroundImage: item.background
                                                ? `url(${item.background})`
                                                : "none",
                                        }}
                                    />
                                    <div className={Styles.projectInfoDetailsWrap}>
                                        <div className={Styles.projectInfoDetailsWrapTitle}>
                                            {item.description?.title}
                                        </div>
                                        <div className={Styles.projectInfoDetailsWrapDescription}>
                                            {item.description?.short_description}
                                        </div>
                                        <div className={Styles.projectInfoDetailsBox}>
                                            <div className={Styles.projectInfoDetailsBoxItem}>
                                                <div
                                                    className={Styles.projectInfoDetailsBoxItemName}
                                                >
                                                    {t("Целевая сумма финансирования")}
                                                </div>
                                                <div
                                                    className={Styles.projectInfoDetailsBoxItemValue}
                                                >
                                                    ${item.fundraise_goal * 1}
                                                </div>
                                            </div>
                                            <div className={Styles.projectInfoDetailsBoxItem}>
                                                <div
                                                    className={Styles.projectInfoDetailsBoxItemName}
                                                >
                                                    {t("Максимальная аллокация")}
                                                </div>
                                                <div
                                                    className={Styles.projectInfoDetailsBoxItemValue}
                                                >
                                                    ${item.max_allocation * 1}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={Styles.btn}>
                                    {projectsStatusHandler(item.status)}
                                </div>
                            </div>
                        ))
                        : null}
                </div>

                {/* Пагинация */}
                {lastPage > 1 && (
                    <div className={Styles.pagination}>
                        {/* Prev */}
                        <button
                            type="button"
                            className={`${Styles.pageArrow} ${
                                currentPage === 1
                                    ? Styles.pageArrowDisabled
                                    : Styles.pageArrowActive
                            }`}
                            onClick={handlePrev}
                            disabled={currentPage === 1}
                        >
                            &lt;
                        </button>

                        {/* Номера страниц и ... */}
                        {paginationItems.map((item, idx) => {
                            if (typeof item === "string" && item.startsWith("dots")) {
                                return (
                                    <div key={`dots-${idx}`} className={Styles.pageDots}>
                                        …
                                    </div>
                                );
                            }

                            const pageNum = item;
                            const isActive = pageNum === currentPage;

                            return (
                                <button
                                    type="button"
                                    key={`page-${pageNum}`}
                                    className={`${Styles.pageBtn} ${
                                        isActive ? Styles.pageBtnActive : Styles.pageBtnDefault
                                    }`}
                                    onClick={() => goToPage(pageNum)}
                                >
                                    {pageNum}
                                </button>
                            );
                        })}

                        {/* Next */}
                        <button
                            type="button"
                            className={`${Styles.pageArrow} ${
                                currentPage === lastPage
                                    ? Styles.pageArrowDisabled
                                    : Styles.pageArrowActive
                            }`}
                            onClick={handleNext}
                            disabled={currentPage === lastPage}
                        >
                            &gt;
                        </button>
                    </div>
                )}
            </div>
        </section>
    );
};

export default LaunchpadProjectsAllPage;

